import React, { useEffect, useRef, useState } from 'react'
import Banner from './Banner';
import { ReactComponent as SuccessIcon } from '../../assets/icons/success.svg';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import * as animationData from '../../assets/success_lottie.json'
import Lottie from 'react-lottie';

const numberOfDigits = 6
const SiteVisitVerification = ({
    setChannelPartner,
    otpVerifield,
    handleVerifyOTP,
    countDown,
    disableResend,
    mobile,
    otpError,
    handleSendOTP,
    name,
    email,
    handleSubmitCPVisit,
    isCPVisit, isSubmitting, setShowCustomerRevisitModal, isRevisit }) => {
    const [otpVal, setOTPVal] = useState([]);
    const inputRef = useRef(null);
    const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
    const otpBoxReference = useRef([]);

    function handleChange(value, index) {
        // if (value) {
        let newArr = [...otp];
        const inputValue = value;
        console.log(value, 'valuess')
        // Allow only one digit between 0 and 9
        if (inputValue === '' || (inputValue.length === 1 && /^[0-9]$/.test(inputValue))) {
            //   setValue(inputValue);
            newArr[index] = inputValue
            setOtp(newArr);
        }

        if (value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus()
        }
        // }
    }

    function handleBackspaceAndEnter(e, index) {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpBoxReference.current[index - 1].focus()
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus()
        }
    }


    // const inputfocus = (e) => {
    //     if (e.key === "Delete" || e.key === "Backspace") {
    //         let newVal = [...otpVal]
    //         newVal[e.target.tabIndex] = ''
    //         setOTPVal(newVal)
    //         setOTP(newVal)
    //         const previousElementSibling =
    //             e.target.previousElementSibling;

    //         if (previousElementSibling) {
    //             previousElementSibling.focus();
    //         }
    //     }
    //     else {
    //         console.log(e.target.value, 'valuess')
    //         const nextElementSibling = e.target.nextElementSibling;
    //         let newVal = [...otpVal]
    //         newVal[e.target.tabIndex] = e.target.value
    //         setOTPVal(newVal)
    //         setOTP(newVal);
    //         if (nextElementSibling) {
    //             nextElementSibling.focus();
    //         }

    //     }
    // }

    return (
        <div className=' mx-auto overflow-auto '>
            <div className='!w-full broker-info'>
                <Banner />
            </div>
            {!otpVerifield && <>
                <div className='flex items-center !my-3 sm:!my-6 !py-6 sm:!py-12 bg-white rounded-xl'>
                    {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                    <p className='flex items-center mb-0 mx-4 sm:!mx-10'>
                        <span className='cursor-pointer' onClick={() => {
                            if (isRevisit) {
                                setChannelPartner('1')
                                setShowCustomerRevisitModal(true)
                            } else {
                                setChannelPartner('5')
                            }
                        }}>
                            <LeftArrowIcon className='stroke-black800 rotate-180' />
                        </span>
                        <span className='text-lg sm:text-2xl font-medium ml-4 sm:!ml-12'>Verify your Site Visit</span>
                        {/* <span className='text-xl !mt-4'>Powered By Propacity</span> */}
                    </p>
                    {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                </div>
                <div className='bg-white rounded-xl  p-4 sm:!p-10 space-y-6'>
                    <h3 className='text-lg sm:text-xl'>Site Visit Code</h3>
                    <p className='text-sm sm:text-lg text-black700'>
                        SV Code sent to <span className='text-textblack font-medium'>{name}</span> (<span className='text-textblack font-medium'>{mobile}</span>) {email ? 'and' : ''} <span className='text-textblack font-medium'>{email}</span>
                        {/* Enter the Code sent to  <span className='text-textblack font-medium'>{name}</span> on their <br /> Email/Mobile(<span className='text-textblack font-medium'>{mobile}</span>) */}
                    </p>
                    <div className='flex !gap-4'>
                        {otp.map((digit, index) => (
                            <input key={index} value={digit} maxLength={1} min={0} max={9} step={1} type='number'
                                onChange={(e) => handleChange(e.target.value
                                    // .replace(/^0+/g, '')
                                    .replace(/[^0-9]/g, ''), index)}
                                onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                                ref={(reference) => (otpBoxReference.current[index] = reference)}
                                className='w-[33px] h-[33px] sm:w-[80px] sm:h-[80px] font-semibold rounded-lg  bg-[#EAECF0] focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            />
                        ))}
                        {/* <input
                            className='w-[45px] h-[45px] sm:w-[80px] sm:h-[80px] font-semibold rounded-lg  bg-[#EAECF0] focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            type="number"
                            tabIndex="0" onKeyUp={e => inputfocus(e)}
                            min='0' max='9' step='1'
                            ref={inputRef}
                        />
                        <input className='w-[45px] h-[45px] sm:w-[80px] sm:h-[80px] font-semibold bg-[#EAECF0] rounded-lg focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            type="number" min='0' max='9' step='1' tabIndex="1" onKeyUp={e => inputfocus(e)}
                        />
                        <input
                            className='w-[45px] h-[45px] sm:w-[80px] sm:h-[80px] font-semibold rounded-lg bg-[#EAECF0] focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            type="number" tabIndex="2" min='0' max='9' step='1' onKeyUp={e => inputfocus(e)}
                        />
                        <input className='w-[45px] h-[45px] sm:w-[80px] sm:h-[80px] font-semibold rounded-lg bg-[#EAECF0] focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            type="number" tabIndex="3" min='0' max='9' step='1' onKeyUp={e => inputfocus(e)}
                        />
                        <input className='w-[45px] h-[45px] sm:w-[80px] sm:h-[80px] font-semibold rounded-lg bg-[#EAECF0] focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            type="number" tabIndex="4" min='0' max='9' step='1' onKeyUp={e => inputfocus(e)}
                        />
                        <input className='w-[45px] h-[45px] sm:w-[80px] sm:h-[80px] font-semibold rounded-lg bg-[#EAECF0] focus:!border-blue-900 outline-0 shadow-0 text-center focus:text-blue-900 text-textblack text-sm sm:text-2xl'
                            type="number" tabIndex="5" min='0' max='9' step='1' onKeyUp={e => inputfocus(e)}
                        /> */}
                    </div>
                    {otpError && <div className="input-feedback sm:!text-sm text-xs text-red !mt-3  sm:!mt-6 ml-2">Incorrect OTP, Please Retry.</div>}
                    <div className=' text-sm sm:text-xl !mt-10'>
                        Haven’t Received the Code ?
                        <button
                            className={`text-[#3B37F5] border-0 font-medium leading-5 ml-1 disabled:bg-transparent disabled:hover:bg-transparent disabled:cursor-not-allowed disabled:text-grey-200`} disabled={disableResend} onClick={() => {
                                handleSendOTP();
                            }}> {countDown > 0 ? `Resend Code (${countDown})` : 'Send Again'}
                        </button>
                    </div>
                    <div className='w-full sm:space-x-4 sm:space-y-0 space-y-4 space-y-reverse flex flex-col-reverse sm:flex-row !mt-6 sm:!mt-20' >
                        <button className='w-full sm:w-[1/2] text-base sm:!text-lg border rounded-xl !py-2 sm:!py-3.5' onClick={() => {
                            if (isRevisit) {
                                setChannelPartner('1')
                                setShowCustomerRevisitModal(true)
                            } else {
                                setChannelPartner('5')
                            }
                        }}>Back</button>
                        <button className='w-full sm:w-[1/2] text-base sm:!text-lg rounded-xl !py-2 sm:!py-3.5 bg-blue-900 text-white' disabled={isSubmitting} onClick={() => {
                            if (isCPVisit) {
                                handleSubmitCPVisit(otp.join(''))
                            } else {
                                handleVerifyOTP(otp.join(''))
                            }
                        }}>Next</button>
                    </div>
                </div>
            </>}
            {
                otpVerifield && <div className='flex items-center flex-col justify-center !my-3 sm:!my-6 !py-6 sm:!py-10 bg-white rounded-xl sm:h-[52vh]'>
                    {/* <SuccessIcon className='' /> */}
                    <div className='h-[100px] w-[100px] sm:hidden'>

                        <Lottie
                            height={100}
                            width={100}
                            options={
                                { animationData: animationData }
                            }
                        />
                    </div>
                    <div className=' hidden sm:block sm:h-[200px] sm:w-[200px] md:hidden '>

                        <Lottie
                            height={200}
                            width={200}

                            options={
                                { animationData: animationData }
                            }
                        />
                    </div>
                    <div className=' hidden md:block md:h-[150px] md:w-[200px]'>

                        <Lottie
                            height={200}
                            width={200}

                            options={
                                { animationData: animationData }
                            }
                        />
                    </div>
                    {/* <input accept=”image/*” id=”icon-button-file” type=”file” capture=”environment” /> */}

                    <h3 className='!mt-9 xl:mt-6 text-xl sm:text-3xl font-semibold'>Successfully Registered !</h3>
                    <p className='text-lg text-center sm:text-xl !mt-4 !px-4'>Your Site Visit have been completed Successfully.</p>

                    <button className='w-[95%] sm:w-1/2 !mt-10 xl:!mt-2 text-lg sm:!text-xl font-semibold rounded-xl sm:rounded-lg py-2 sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                        window.location.reload()
                    }}>Register New Customer</button>

                </div>
            }
        </div >
    )
}

export default SiteVisitVerification